export default "__VITE_ASSET__8fb967b0__"